module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAQAAAAD+Fb1AAAAEklEQVQIW2NgmMnAAMYIgC4CADcgAmV+y4KLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/overlay.png
// module id = 245
// module chunks = 0